import { Instance, types } from 'mobx-state-tree'
import { statsData } from '../static/dummydata'
import { getHourlyStats, getStatsByIndex, Stats } from '../parser/view/StatisticsParser'

export const TrendTypes = {
  Hourly: 'Hourly',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  Date: 'Date',
}

const Trend = types.model('Trend', {
  salesVolume: types.string,
  numOfTransactions: types.number,
  successRate: types.string,
  numOfRefunds: types.number,
  numOfDisputes: types.number,
  toolTip: types.string,
  type: types.enumeration(Object.values(TrendTypes)),
})

const TransactionTrends = types
  .model('TransactionTrends', {
    trend: types.array(Trend),
  })
  .views((self) => ({
    getStats(index: number): Stats {
      return getStatsByIndex(index, self.trend) ?? getHourlyStats(self.trend)
    },
  }))

const TransactionTrendData = { trend: statsData }

export type TrendType = Instance<typeof Trend>

export { TransactionTrends, TransactionTrendData }
